import { useTranslation } from 'react-i18next';
import { Modal, Tabs } from '@teo/components';
import { useState } from 'react';
import { Portal } from '@/components/Portal';
import { UploadVideo } from './UploadVideo';
import { UploadByUrl } from './UploadByUrl';
import { UploadEmbedded } from './UploadEmbedded';
import { UploadFromCamera } from './UploadFromCamera';

export const VideoUploadModal = ({
  setIsOpenVideoModal,
  isOpenVideoModal,
  setNewAsset,
}) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState('upload');
  const [mediaStream, setMediaStream] = useState();

  const stop = () => {
    if (mediaStream && typeof mediaStream.getTracks === 'function') {
      mediaStream.getTracks().forEach((track) => track.stop());
    }
  };

  const closeModal = () => {
    stop();
    setIsOpenVideoModal(!isOpenVideoModal);
  };

  return (
    <Portal root="body">
      <div className="z-10 bg-white">
        <Modal isOpen={isOpenVideoModal}>
          <Modal.Header onClose={() => closeModal()}>
            {t('extra_info.upload_video')}
          </Modal.Header>
          <Modal.Body>
            <div className="mb-6 flex flex-col lg:flex-row">
              <Tabs
                activeName={tab}
                onChange={(tab) => {
                  stop();
                  setMediaStream(undefined);
                  setTab(tab);
                }}
              >
                <Tabs.TabButton name="upload">
                  <p className="text-base font-medium">
                    {t('pages.create_edit_course.video_upload_modal.upload')}
                  </p>
                </Tabs.TabButton>
                <Tabs.TabButton name="by-url">
                  <p className="text-base font-medium">
                    {t(
                      'pages.create_edit_course.video_upload_modal.upload_url'
                    )}
                  </p>
                </Tabs.TabButton>
                <Tabs.TabButton name="embedd">
                  <p className="text-base font-medium">
                    {t(
                      'pages.create_edit_course.video_upload_modal.upload_embed'
                    )}
                  </p>
                </Tabs.TabButton>
                <Tabs.TabButton name="camera">
                  <p className="text-base font-medium">
                    {t(
                      'pages.create_edit_course.video_upload_modal.upload_camera'
                    )}
                  </p>
                </Tabs.TabButton>
              </Tabs>
            </div>
            {tab === 'upload' && (
              <UploadVideo setNewAsset={setNewAsset} closeModal={closeModal} />
            )}
            {tab === 'by-url' && (
              <UploadByUrl setNewAsset={setNewAsset} closeModal={closeModal} />
            )}
            {tab === 'embedd' && (
              <UploadEmbedded
                setNewAsset={setNewAsset}
                closeModal={closeModal}
              />
            )}
            {tab === 'camera' && (
              <UploadFromCamera
                setNewAsset={setNewAsset}
                closeModal={closeModal}
                setMediaStream={setMediaStream}
                mediaStream={mediaStream}
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </Portal>
  );
};
